import { sample } from 'effector';
import { putEconomicsDataEv } from './events.js';
import { $economicsStore } from './stores.js';

sample({
  clock: putEconomicsDataEv,
  target: $economicsStore,
});
